import styled from 'styled-components';

export const StyledOption = styled.div`
    display: flex;
    align-items: center;
    text-transform: capitalize;
    gap: 0.5rem;

    p {
        margin-bottom: 0;
    }

    .highlight {
        font-weight: bold;
    }

    span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;

export const StyledAutocompleteContainer = styled.div`
    height: ${(props) => (props.$isMobile ? '56px' : '60px')};
    padding-left: ${(props) => props.$isMobile && '.5rem'};
    padding-right: ${(props) => !props.$isMobile && '1rem'};
    text-align: left;
    width: ${(props) =>
        props.activeSearch || props.openMode
            ? props.$isMobile
                ? '14rem'
                : props.$isTablet
                  ? '18rem'
                  : '25rem'
            : '12.5rem'};

    display: flex;
    align-items: center;

    .ant-select {
        width: 100%;
        max-width: 24.5rem;
        border: none;
        border: none;
        font-size: 1em;
        background-color: transparent;

        .ant-select-selector {
            height: 36px;
            display: flex;
            align-items: center;
            border-radius: 80px;
            padding: ${(props) => (props.$isMobile ? '4px 16px 4px 36px' : '4px 16px 4px 32px')};
            font-size: 0.95rem;

            .ant-select-selection-search {
                padding-left: ${(props) => (props.$isMobile ? '24px' : '20px')};
            }
            input {
                //font-size: 0.95rem;
                font-size: 16px;
                height: 100% !important;
                padding-bottom: 1px !important;
            }
        }

        .ant-select-selection {
            border: none;
            background-color: transparent;
        }

        input {
            border: none;
            line-height: 1.5em;
            font-size: 1.3em;
            height: auto;
            padding: 0;
            outline: none !important;
            box-shadow: none;

            &:focus,
            &:focus-within,
            &:active,
            &:hover {
                outline: none !important;
                box-shadow: none;
            }
        }

        svg {
            cursor: pointer;
            margin-left: 16px;
        }
    }

    .select-wrapper {
        width: 100%;
        display: flex;
        align-items: center;
        position: relative;
        svg {
            position: absolute;
            left: 12px;
            z-index: 1;
            font-size: 1.2rem;
        }
    }
`;

export const GlobalSearchWrapper = styled.div`
    padding-bottom: 2rem;
    .rc-virtual-list-holder {
        max-height: 80vh !important;

        .ant-select-item-group {
            padding-left: 24px;
        }

        .ant-select-item-option-content {
            span {
                margin: 0 20px 0 0 !important;
            }
        }

        .ant-select-item-option-grouped {
            padding-left: 56px !important;
        }
    }
`;

export const GlobalSearchWrapperContainer = styled.div`
    width: ${(props) => props.$isMobile && '100%'};
`;
